<template>
  <ui-card name="trip.summary" :error="error" rounded>
    <div class="trip-overview">
      <div class="level">
        <div class="level-left">
          {{ $t('ui.labels.user_id') }}:
          <output>{{ user.id }}</output>
        </div>
        <div class="level-right">
          <ui-copy-button v-if="user.id" :value="user.id" />
        </div>
      </div>
      <div class="level">
        <div class="level-left">
          {{ $t('trip.summary.distance_covered') }}:
          <output>{{ $t('ui.values.km', [distances.total]) }}</output>
          <span class="recent"
            >{{ $t('ui.values.km', [distances.recent]) }} ({{
              $t('trip.summary.last_7_days')
            }})</span
          >
        </div>
      </div>
    </div>
    <score-collection class="trip-scores" :values="scores" />
  </ui-card>
</template>

<script>
import ScoreCollection from 'charts/ScoreCollection';
import { driving } from 'config/settings';

export default {
  components: {
    ScoreCollection,
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    error() {
      if (
        this.scores.length === 0 &&
        Object.keys(this.distances).length === 0
      ) {
        return 'learning';
      }
      if (this.scores.every(score => score.value === 0)) {
        return 'missing_data';
      }
    

      return '';
    },

    scores() {
      const behavior = this.user.car_behavior;
      if (behavior) {
        const scores = behavior.scores.past.all;
        return driving.types.map(type => {
          return {
            label: `trip.driving_behavior.${type}`,
            tooltip: `trip.driving_behavior_tooltip.${type}`,
            value: scores[type] * 100,
          };
        });
      }
      return [];
    },

    distances() {
      const behavior = this.user.car_behavior;
      if (behavior) {
        const past = behavior.features.past.distance / 1000;
        const recent = behavior.features.l7d.distance / 1000;
        return {
          total: (past + recent).toFixed(1),
          recent: recent.toFixed(1),
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.trip-overview {
  padding: 1rem;
  font-size: 0.875rem;
  vertical-align: baseline;

  border-bottom: 1px solid $white-ter;

  .recent {
    color: rgba(black, 0.5);
    border-left: 1px solid rgba(black, 0.3);
    margin-left: 0.5rem;
    padding-left: 0.5rem;
  }
}

.trip-scores {
  background-color: rgba($black, 0.02);
}

.level {
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
}

output {
  font-weight: $weight-medium;
  padding-left: 0.5em;
}

.card-header-link {
  top: 2px;
}
</style>
